import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, createBlock as _createBlock, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = { class: "edit-exam-view exam-view-container" }
const _hoisted_2 = { class: "mb-6" }
const _hoisted_3 = { class: "flex items-center mb-4" }
const _hoisted_4 = {
  key: 0,
  class: "mt-6 flex flex-col justify-center items-center py-12"
}
const _hoisted_5 = {
  key: 1,
  class: "mt-6 bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-800 rounded-lg p-4 mb-6"
}
const _hoisted_6 = { class: "flex items-center" }
const _hoisted_7 = { class: "text-red-700 dark:text-red-300 font-medium" }
const _hoisted_8 = {
  key: 2,
  class: "grid grid-cols-1 xl:grid-cols-3 gap-6"
}
const _hoisted_9 = { class: "xl:col-span-2 space-y-6" }
const _hoisted_10 = { class: "card" }
const _hoisted_11 = { class: "card-header" }
const _hoisted_12 = { class: "flex items-center" }
const _hoisted_13 = { class: "w-8 h-8 rounded-lg bg-blue-100 dark:bg-blue-900/30 flex items-center justify-center mr-3" }
const _hoisted_14 = { class: "card-body space-y-4" }
const _hoisted_15 = ["value"]
const _hoisted_16 = { class: "grid grid-cols-1 md:grid-cols-3 gap-4" }
const _hoisted_17 = { class: "card" }
const _hoisted_18 = { class: "card-header" }
const _hoisted_19 = { class: "flex items-center justify-between" }
const _hoisted_20 = { class: "flex items-center" }
const _hoisted_21 = { class: "w-8 h-8 rounded-lg bg-green-100 dark:bg-green-900/30 flex items-center justify-center mr-3" }
const _hoisted_22 = { class: "text-lg font-semibold text-primary-text dark:text-primary-dark-text" }
const _hoisted_23 = { class: "card-body space-y-6" }
const _hoisted_24 = {
  key: 0,
  class: "text-center py-8"
}
const _hoisted_25 = { class: "w-16 h-16 rounded-full bg-gray-100 dark:bg-gray-800 flex items-center justify-center mx-auto mb-4" }
const _hoisted_26 = { class: "flex items-center justify-between" }
const _hoisted_27 = { class: "flex items-center gap-2" }
const _hoisted_28 = { class: "text-lg font-medium text-primary-text dark:text-primary-dark-text" }
const _hoisted_29 = {
  key: 0,
  class: "text-xs px-2 py-1 bg-green-100 dark:bg-green-900/30 text-green-700 dark:text-green-300 rounded-full"
}
const _hoisted_30 = {
  key: 1,
  class: "text-xs px-2 py-1 bg-red-100 dark:bg-red-900/30 text-red-700 dark:text-red-300 rounded-full"
}
const _hoisted_31 = {
  key: 0,
  class: "p-2 bg-red-100 dark:bg-red-900/20 border border-red-200 dark:border-red-800 rounded text-sm"
}
const _hoisted_32 = { class: "text-red-600 dark:text-red-400 text-xs space-y-1" }
const _hoisted_33 = ["onUpdate:modelValue", "onChange"]
const _hoisted_34 = ["onUpdate:modelValue"]
const _hoisted_35 = { key: 1 }
const _hoisted_36 = { class: "space-y-3" }
const _hoisted_37 = ["for"]
const _hoisted_38 = { class: "radio-option-content" }
const _hoisted_39 = { class: "radio-button-wrapper" }
const _hoisted_40 = ["id", "name", "value", "checked", "onChange"]
const _hoisted_41 = { class: "radio-button" }
const _hoisted_42 = { class: "option-letter" }
const _hoisted_43 = ["onUpdate:modelValue", "placeholder"]
const _hoisted_44 = {
  key: 0,
  class: "flex items-center"
}
const _hoisted_45 = ["onClick"]
const _hoisted_46 = ["onClick"]
const _hoisted_47 = ["onClick"]
const _hoisted_48 = { key: 2 }
const _hoisted_49 = { class: "grid grid-cols-1 sm:grid-cols-2 gap-3" }
const _hoisted_50 = ["for"]
const _hoisted_51 = ["id", "name", "checked", "onChange"]
const _hoisted_52 = { class: "true-false-content" }
const _hoisted_53 = { class: "true-false-icon" }
const _hoisted_54 = ["for"]
const _hoisted_55 = ["id", "name", "checked", "onChange"]
const _hoisted_56 = { class: "true-false-content" }
const _hoisted_57 = { class: "true-false-icon" }
const _hoisted_58 = { key: 3 }
const _hoisted_59 = {
  key: 1,
  class: "text-center mt-4"
}
const _hoisted_60 = { class: "space-y-6" }
const _hoisted_61 = { class: "sticky-sidebar" }
const _hoisted_62 = { class: "card" }
const _hoisted_63 = { class: "card-body space-y-4" }
const _hoisted_64 = { class: "flex items-center justify-between" }
const _hoisted_65 = { class: "font-medium text-primary-text dark:text-primary-dark-text" }
const _hoisted_66 = { class: "flex items-center justify-between" }
const _hoisted_67 = { class: "font-medium text-primary-text dark:text-primary-dark-text" }
const _hoisted_68 = { class: "flex items-center justify-between" }
const _hoisted_69 = { class: "font-medium text-primary-text dark:text-primary-dark-text" }
const _hoisted_70 = { class: "flex items-center justify-between" }
const _hoisted_71 = { class: "font-medium text-primary-text dark:text-primary-dark-text" }
const _hoisted_72 = { class: "flex items-center justify-between" }
const _hoisted_73 = { class: "font-medium text-primary-text dark:text-primary-dark-text" }
const _hoisted_74 = { class: "flex items-center justify-between" }
const _hoisted_75 = { class: "font-medium text-primary-text dark:text-primary-dark-text" }
const _hoisted_76 = { class: "pt-3 border-t border-gray-200 dark:border-gray-700" }
const _hoisted_77 = { class: "flex items-center justify-between mb-2" }
const _hoisted_78 = {
  key: 0,
  class: "text-xs px-2 py-1 bg-green-100 dark:bg-green-900/30 text-green-700 dark:text-green-300 rounded-full"
}
const _hoisted_79 = {
  key: 1,
  class: "text-xs px-2 py-1 bg-red-100 dark:bg-red-900/30 text-red-700 dark:text-red-300 rounded-full"
}
const _hoisted_80 = {
  key: 0,
  class: "text-xs text-red-600 dark:text-red-400 space-y-1"
}
const _hoisted_81 = { key: 0 }
const _hoisted_82 = { key: 1 }
const _hoisted_83 = { key: 2 }
const _hoisted_84 = { key: 3 }
const _hoisted_85 = { key: 4 }
const _hoisted_86 = { class: "mt-2 card" }
const _hoisted_87 = { class: "card-body space-y-3" }
const _hoisted_88 = ["disabled"]
const _hoisted_89 = ["disabled"]

import { ref, computed, onMounted } from 'vue'
import { useTitle } from '@/composables/ui/useTitle'
import { useToastService } from '@/services/toast'
import { examService } from '@/services/examService'
import type { Question, Exam, UpdateExamPayload } from '@/services/examService'
import type { Module } from '@/services/modules'
import IncompleteQuestionsModal from '@/components/modals/IncompleteQuestionsModal.vue'
import KeywordInput from '@/components/forms/KeywordInput.vue'
import {
  FileText,
  ArrowLeft,
  HelpCircle,
  Save,
  AlertCircle,
  X,
  Check,
  ArrowUp
} from 'lucide-vue-next'

// Props and Emits
interface Props {
  examId: number
}


export default /*@__PURE__*/_defineComponent({
  __name: 'EditExamView',
  props: {
    examId: {}
  },
  emits: ["back", "examUpdated"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

// Page title
const appTitle = computed(() => process.env.VUE_APP_TITLE || 'Empathy Health Services, Inc.')
const { setTitle } = useTitle(`Edit Exam - ${appTitle.value}`)

const handleBack = () => {
  setTitle(`Exams - ${appTitle.value}`)
  emit('back')
}

// Services
const toastService = useToastService()

// Helper function to maintain backward compatibility
const showToast = (message: string, type: 'success' | 'error' | 'info' = 'info') => {
  if (type === 'success') {
    toastService.success(message)
  } else if (type === 'error') {
    toastService.error(message)
  } else {
    toastService.success(message) // Use success for info since the service may not have info
  }
}

// State
const loading = ref(false)
const updating = ref(false)
const error = ref('')
const exam = ref<Exam | null>(null)
const modules = ref<Module[]>([])
const showIncompleteModal = ref(false)
const pendingUpdateType = ref<'exam' | 'draft'>('exam')
const originalExamData = ref<string>('') // Store original exam data as JSON string for comparison

// Form state - will be populated when exam loads
const examForm = ref<UpdateExamPayload & { exam_content: { questions: Question[] } }>({
  exam_name: '',
  module_id: 0,
  exam_content: {
    questions: []
  },
  answer_key: {},
  passing_rate: 70,
  time_limit: null,
  total_attempts: 3,
  exam_status: 1
})

// Computed properties
const hasFormChanged = computed(() => {
  if (!originalExamData.value) return false
  
  // Create a comparable version of current form data
  const currentData = JSON.stringify({
    exam_name: examForm.value.exam_name,
    module_id: examForm.value.module_id,
    exam_content: examForm.value.exam_content,
    answer_key: examForm.value.answer_key,
    passing_rate: examForm.value.passing_rate,
    time_limit: examForm.value.time_limit,
    total_attempts: examForm.value.total_attempts,
    exam_status: examForm.value.exam_status
  })
  
  return currentData !== originalExamData.value
})

const canSaveExam = computed(() => {
  // Check if any changes were made (only for "Update Exam", not for draft)
  if (!hasFormChanged.value) {
    return false
  }

  // Check if exam name is filled
  if (!examForm.value.exam_name || !examForm.value.exam_name.trim()) {
    return false
  }

  // Check if passing rate is set (should be between 1 and 100)
  if (!examForm.value.passing_rate || examForm.value.passing_rate <= 0 || examForm.value.passing_rate > 100) {
    return false
  }

  // Check if module is selected
  if (!examForm.value.module_id || examForm.value.module_id <= 0) {
    return false
  }

  // Check if there are any questions
  if (examForm.value.exam_content.questions.length === 0) {
    return false
  }

  // Check if at least one question is properly filled
  const hasValidQuestion = examForm.value.exam_content.questions.some((question: Question) => {
    // Question text must be filled
    if (!question.question.trim()) {
      return false
    }

    // Check based on question type
    if (question.type === 'multiple_choice') {
      // Must have at least 2 options with text, and a correct answer selected
      const validOptions = question.options?.filter(option => option.text && option.text.trim()) || []
      const hasCorrectAnswer = examForm.value.answer_key && examForm.value.answer_key[question.id]
      return validOptions.length >= 2 && hasCorrectAnswer
    } else if (question.type === 'true_false') {
      // Must have a correct answer selected
      return examForm.value.answer_key && examForm.value.answer_key[question.id] !== undefined && examForm.value.answer_key[question.id] !== ''
    } else if (question.type === 'essay') {
      // Must have at least one keyword
      const keywords = getEssayKeywords(question.id)
      return keywords.length > 0
    }

    return false
  })

  return hasValidQuestion
})

const canSaveAsDraft = computed(() => {
  // For draft, we don't require changes - just basic validation
  // Check if exam name is filled
  if (!examForm.value.exam_name || !examForm.value.exam_name.trim()) {
    return false
  }

  // Check if passing rate is set (should be between 1 and 100)
  if (!examForm.value.passing_rate || examForm.value.passing_rate <= 0 || examForm.value.passing_rate > 100) {
    return false
  }

  // Check if module is selected
  if (!examForm.value.module_id || examForm.value.module_id <= 0) {
    return false
  }

  // Check if there are any questions
  if (examForm.value.exam_content.questions.length === 0) {
    return false
  }

  // Check if at least one question is properly filled
  const hasValidQuestion = examForm.value.exam_content.questions.some((question: Question) => {
    // Question text must be filled
    if (!question.question.trim()) {
      return false
    }

    // Check based on question type
    if (question.type === 'multiple_choice') {
      // Must have at least 2 options with text, and a correct answer selected
      const validOptions = question.options?.filter(option => option.text && option.text.trim()) || []
      const hasCorrectAnswer = examForm.value.answer_key && examForm.value.answer_key[question.id]
      return validOptions.length >= 2 && hasCorrectAnswer
    } else if (question.type === 'true_false') {
      // Must have a correct answer selected
      return examForm.value.answer_key && examForm.value.answer_key[question.id] !== undefined && examForm.value.answer_key[question.id] !== ''
    } else if (question.type === 'essay') {
      // Must have at least one keyword
      const keywords = getEssayKeywords(question.id)
      return keywords.length > 0
    }

    return false
  })

  return hasValidQuestion
})

// Helper computed to track which questions are incomplete
const incompleteQuestions = computed(() => {
  return examForm.value.exam_content.questions.map((question: Question, index: number) => {
    const issues: string[] = []
    
    // Check if question text is filled
    if (!question.question.trim()) {
      issues.push('Question text is required')
    }
    
    // Check based on question type
    if (question.type === 'multiple_choice') {
      const validOptions = question.options?.filter(option => option.text && option.text.trim()) || []
      
      // Check if options are filled in order (no gaps)
      if (question.options) {
        for (let i = 0; i < question.options.length; i++) {
          const currentOption = question.options[i]
          const isEmpty = !currentOption.text || !currentOption.text.trim()
          
          if (isEmpty) {
            // Check if there are filled options after this empty one
            const hasFilledAfter = question.options.slice(i + 1).some(opt => opt.text && opt.text.trim())
            if (hasFilledAfter) {
              issues.push(`Option ${String.fromCharCode(65 + i)} must be filled before later options`)
            }
          }
        }
      }
      
      if (validOptions.length < 2) {
        issues.push('At least 2 options must be filled')
      }
      if (!examForm.value.answer_key || !examForm.value.answer_key[question.id]) {
        issues.push('Correct answer must be selected')
      }
    } else if (question.type === 'true_false') {
      if (!examForm.value.answer_key || examForm.value.answer_key[question.id] === undefined || examForm.value.answer_key[question.id] === '') {
        issues.push('Correct answer must be selected')
      }
    } else if (question.type === 'essay') {
      const keywords = getEssayKeywords(question.id)
      if (keywords.length === 0) {
        issues.push('At least one keyword is required')
      }
    }
    
    return {
      index,
      isComplete: issues.length === 0,
      issues
    }
  })
})

// Helper function to check if a question is complete
const isQuestionComplete = (question: Question): boolean => {
  // Check if question text is filled
  if (!question.question.trim()) {
    return false
  }
  
  // Check based on question type
  if (question.type === 'multiple_choice') {
    const validOptions = question.options?.filter(option => option.text && option.text.trim()) || []
    
    // Check if options are filled in order (no gaps)
    if (question.options) {
      for (let i = 0; i < question.options.length; i++) {
        const currentOption = question.options[i]
        const isEmpty = !currentOption.text || !currentOption.text.trim()
        
        if (isEmpty) {
          // Check if there are filled options after this empty one
          const hasFilledAfter = question.options.slice(i + 1).some(opt => opt.text && opt.text.trim())
          if (hasFilledAfter) {
            return false // Has gaps in options
          }
        }
      }
    }
    
    if (validOptions.length < 2) {
      return false
    }
    if (!examForm.value.answer_key || !examForm.value.answer_key[question.id]) {
      return false
    }
  } else if (question.type === 'true_false') {
    if (!examForm.value.answer_key || examForm.value.answer_key[question.id] === undefined || examForm.value.answer_key[question.id] === '') {
      return false
    }
  } else if (question.type === 'essay') {
    const keywords = getEssayKeywords(question.id)
    if (keywords.length === 0) {
      return false
    }
  }
  
  return true
}

// Scroll helper to go back to top of this view
const scrollToTop = () => {
  const el = document.querySelector('.edit-exam-view') as HTMLElement | null
  if (el) {
    el.scrollIntoView({ behavior: 'smooth' })
  } else {
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }
}

// Computed property for modal data - reuses incompleteQuestions logic
const modalQuestionsData = computed(() => {
  return incompleteQuestions.value.map((questionData) => ({
    index: questionData.index,
    question: examForm.value.exam_content.questions[questionData.index]?.question || '',
    isComplete: questionData.isComplete,
    issues: questionData.issues
  }))
})

// Methods
const loadExam = async () => {
  try {
    loading.value = true
    error.value = ''
    
    const response = await examService.getExam(props.examId)
    exam.value = response.data.data
    
    // Populate form with exam data
    examForm.value = {
      exam_name: exam.value.exam_name,
      module_id: exam.value.module_id,
      exam_content: {
        questions: [...exam.value.exam_content.questions] // Deep copy
      },
      answer_key: { ...exam.value.answer_key }, // Deep copy
      passing_rate: exam.value.passing_rate,
      time_limit: exam.value.time_limit,
      total_attempts: exam.value.total_attempts,
      exam_status: exam.value.exam_status
    }
    
    // Convert legacy essay data (strings) to new format (arrays)
    examForm.value.exam_content.questions.forEach(question => {
      if (question.type === 'essay' && examForm.value.answer_key && examForm.value.answer_key[question.id]) {
        const essayData = examForm.value.answer_key[question.id]
        if (typeof essayData === 'string' && essayData.trim()) {
          // Convert string to array of keywords by splitting on common delimiters
          const keywords = essayData
            .split(/[,;.\n]/)
            .map(keyword => keyword.trim())
            .filter(keyword => keyword !== '')
          examForm.value.answer_key[question.id] = keywords
        } else if (!Array.isArray(essayData)) {
          // Initialize as empty array if not already an array
          examForm.value.answer_key[question.id] = []
        }
      }
    })
    
    // Set modules to only contain the current exam's module
    if (exam.value && exam.value.module) {
      modules.value = [{
        module_id: exam.value.module_id,
        name: exam.value.module.name,
        status: exam.value.module.status,
        description: exam.value.module.description || '',
        added_at: new Date().toISOString(),
        updated_at: new Date().toISOString()
      }]
    }
    
    // Store original exam data for change detection
    originalExamData.value = JSON.stringify({
      exam_name: examForm.value.exam_name,
      module_id: examForm.value.module_id,
      exam_content: examForm.value.exam_content,
      answer_key: examForm.value.answer_key,
      passing_rate: examForm.value.passing_rate,
      time_limit: examForm.value.time_limit,
      total_attempts: examForm.value.total_attempts,
      exam_status: examForm.value.exam_status
    })
    
  } catch (err: any) {
    console.error('Error loading exam:', err)
    error.value = err.response?.data?.message || err.message || 'Failed to load exam'
    showToast('Failed to load exam', 'error')
  } finally {
    loading.value = false
  }
}

// Exam form methods
const updateQuestionType = (question: Question) => {
  // Reset answer key when question type changes
  if (examForm.value.answer_key && examForm.value.answer_key[question.id]) {
    delete examForm.value.answer_key[question.id]
  }
  
  // Initialize answer key based on type
  if (question.type === 'essay') {
    if (!examForm.value.answer_key) {
      examForm.value.answer_key = {}
    }
    examForm.value.answer_key[question.id] = []
  }
  
  // Update options based on type
  if (question.type === 'multiple_choice') {
    question.options = [
      { id: 'a', text: '' },
      { id: 'b', text: '' },
      { id: 'c', text: '' },
      { id: 'd', text: '' }
    ]
  } else {
    delete (question as any).options
  }
}

const addOption = (question: Question) => {
  if (question.options) {
    // Check if all current options are filled before adding a new one
    const hasEmptyOptions = question.options.some(option => !option.text || !option.text.trim())
    
    if (hasEmptyOptions) {
      showToast('Please fill all current options before adding a new one', 'info')
      return
    }
    
    const nextLetter = String.fromCharCode(97 + question.options.length) // a, b, c, d, e, f
    question.options.push({
      id: nextLetter,
      text: ''
    })
  }
}

const removeOption = (question: Question, index: number) => {
  if (question.options && question.options.length > 2) {
    question.options.splice(index, 1)
    // Update option IDs to maintain a, b, c, d sequence
    question.options.forEach((option: { id: string; text: string }, idx: number) => {
      option.id = String.fromCharCode(97 + idx)
    })
    
    // Reset answer key if the selected option was removed
    const answerKey = getAnswerValue(question.id)
    const stillExists = question.options.some(opt => opt.id === answerKey)
    if (!stillExists) {
      setAnswerValue(question.id, '')
    }
  }
}

// Helper function to get validation classes for options
const getOptionValidationClass = (question: Question, optIndex: number) => {
  if (!question.options) return 'border-gray-300 dark:border-gray-600'
  
  const option = question.options[optIndex]
  const isEmpty = !option.text || !option.text.trim()
  
  if (isEmpty) {
    // Check if there are filled options after this empty one
    const hasFilledAfter = question.options.slice(optIndex + 1).some(opt => opt.text && opt.text.trim())
    if (hasFilledAfter) {
      return 'border-red-500 dark:border-red-500 bg-red-50 dark:bg-red-900/10'
    }
    return 'border-gray-300 dark:border-gray-600'
  }
  
  return 'border-green-500 dark:border-green-500 bg-green-50 dark:bg-green-900/10'
}

// Helper functions for answer key management
const getAnswerValue = (questionId: number) => {
  if (!examForm.value.answer_key) return ''
  return examForm.value.answer_key[questionId] || ''
}

const setAnswerValue = (questionId: number, value: any) => {
  if (!examForm.value.answer_key) {
    examForm.value.answer_key = {}
  }
  examForm.value.answer_key[questionId] = value
}

// Helper functions for essay keywords
const getEssayKeywords = (questionId: number): string[] => {
  if (!examForm.value.answer_key) return []
  const keywords = examForm.value.answer_key[questionId]
  return Array.isArray(keywords) ? keywords : []
}

const updateEssayKeywords = (questionId: number, keywords: string[]) => {
  if (!examForm.value.answer_key) {
    examForm.value.answer_key = {}
  }
  examForm.value.answer_key[questionId] = keywords
}

// Input validation functions
const preventDecimalInput = (event: KeyboardEvent) => {
  // Prevent decimal point and minus sign
  if (event.key === '.' || event.key === ',' || event.key === '-' || event.key === 'e' || event.key === 'E') {
    event.preventDefault()
  }
}

const handleTimeLimitInput = (event: Event) => {
  const target = event.target as HTMLInputElement
  let value = target.value
  
  // If empty, set to null (unlimited)
  if (value === '' || value === null) {
    examForm.value.time_limit = null
    return
  }
  
  // Remove any non-digit characters
  value = value.replace(/[^\d]/g, '')
  
  // Convert to number
  let numValue = parseInt(value, 10)
  
  // If NaN, set to null
  if (isNaN(numValue)) {
    examForm.value.time_limit = null
    target.value = ''
    return
  }
  
  // Enforce min and max
  if (numValue < 1) {
    numValue = 1
  } else if (numValue > 1440) {
    numValue = 1440
  }
  
  examForm.value.time_limit = numValue
  target.value = numValue.toString()
}

const handleTotalAttemptsInput = (event: Event) => {
  const target = event.target as HTMLInputElement
  let value = target.value
  
  // If empty, set to null (unlimited)
  if (value === '' || value === null) {
    examForm.value.total_attempts = null
    return
  }
  
  // Remove any non-digit characters
  value = value.replace(/[^\d]/g, '')
  
  // Convert to number
  let numValue = parseInt(value, 10)
  
  // If NaN, set to null
  if (isNaN(numValue)) {
    examForm.value.total_attempts = null
    target.value = ''
    return
  }
  
  // Enforce min and max
  if (numValue < 1) {
    numValue = 1
  } else if (numValue > 10) {
    numValue = 10
  }
  
  examForm.value.total_attempts = numValue
  target.value = numValue.toString()
}

// Helper function to clean exam data before sending
const cleanExamData = (data: UpdateExamPayload & { exam_content: { questions: Question[] } }) => {
  const cleanedData = JSON.parse(JSON.stringify(data)) // Deep clone
  
  // Filter out incomplete questions first, then clean up the remaining complete questions
  cleanedData.exam_content.questions = cleanedData.exam_content.questions
    .filter((question: Question) => isQuestionComplete(question))
    .map((question: Question) => {
      const cleanedQuestion = { ...question }
      
      // For multiple choice questions, filter out empty options
      if (question.type === 'multiple_choice' && question.options) {
        cleanedQuestion.options = question.options.filter(option => 
          option.text && option.text.trim() !== ''
        )
        
        // Re-assign option IDs to maintain sequence (a, b, c, etc.)
        cleanedQuestion.options.forEach((option: { id: string; text: string }, idx: number) => {
          option.id = String.fromCharCode(97 + idx) // a, b, c, d, e, f
        })
      }
      
      // Clean question text
      cleanedQuestion.question = question.question.trim()
      
      return cleanedQuestion
    })

  // Clean answer key - only keep answers for questions that exist and are valid
  const cleanedAnswerKey: Record<string, any> = {}
  cleanedData.exam_content.questions.forEach((question: Question) => {
    if (data.answer_key && data.answer_key[question.id] !== undefined && data.answer_key[question.id] !== '') {
      // For multiple choice, make sure the answer references a valid option
      if (question.type === 'multiple_choice') {
        const validOptionIds = question.options?.map(opt => opt.id) || []
        if (validOptionIds.includes(data.answer_key[question.id])) {
          cleanedAnswerKey[question.id] = data.answer_key[question.id]
        }
      } else {
        cleanedAnswerKey[question.id] = data.answer_key[question.id]
      }
    }
  })

  return {
    ...cleanedData,
    exam_content: {
      questions: cleanedData.exam_content.questions
    },
    answer_key: cleanedAnswerKey,
    exam_name: data.exam_name ? data.exam_name.trim() : ''
  }
}

// Save methods
const updateExam = async () => {
  // Check if exam name is filled
  if (!examForm.value.exam_name || !examForm.value.exam_name.trim()) {
    showToast('Please enter an exam name before saving', 'error')
    return
  }

  // Check if passing rate is set
  if (!examForm.value.passing_rate || examForm.value.passing_rate <= 0 || examForm.value.passing_rate > 100) {
    showToast('Please set a valid passing rate (1-100%)', 'error')
    return
  }

  // Check if module is selected
  if (!examForm.value.module_id || examForm.value.module_id <= 0) {
    showToast('Please select a module before saving', 'error')
    return
  }

  // Check if there are any questions
  if (examForm.value.exam_content.questions.length === 0) {
    showToast('Please add at least one question before saving', 'error')
    return
  }

  // Check if there are any complete questions
  const hasCompleteQuestion = incompleteQuestions.value.some(q => q.isComplete)
  if (!hasCompleteQuestion) {
    showToast('Please complete at least one question before saving', 'error')
    return
  }

  // Check if there are incomplete questions
  const hasIncompleteQuestions = incompleteQuestions.value.some(q => !q.isComplete)
  if (hasIncompleteQuestions) {
    pendingUpdateType.value = 'exam'
    showIncompleteModal.value = true
    return
  }

  // If all questions are complete, proceed directly
  await performUpdate('exam')
}

const updateExamAsDraft = async () => {
  // Check if exam name is filled
  if (!examForm.value.exam_name || !examForm.value.exam_name.trim()) {
    showToast('Please enter an exam name before saving', 'error')
    return
  }

  // Check if passing rate is set
  if (!examForm.value.passing_rate || examForm.value.passing_rate <= 0 || examForm.value.passing_rate > 100) {
    showToast('Please set a valid passing rate (1-100%)', 'error')
    return
  }

  // Check if module is selected
  if (!examForm.value.module_id || examForm.value.module_id <= 0) {
    showToast('Please select a module before saving', 'error')
    return
  }

  // Check if there are any questions
  if (examForm.value.exam_content.questions.length === 0) {
    showToast('Please add at least one question before saving', 'error')
    return
  }

  // Check if there are any complete questions
  const hasCompleteQuestion = incompleteQuestions.value.some(q => q.isComplete)
  if (!hasCompleteQuestion) {
    showToast('Please complete at least one question before saving', 'error')
    return
  }

  // Check if there are incomplete questions
  const hasIncompleteQuestions = incompleteQuestions.value.some(q => !q.isComplete)
  if (hasIncompleteQuestions) {
    pendingUpdateType.value = 'draft'
    showIncompleteModal.value = true
    return
  }

  // If all questions are complete, proceed directly
  await performUpdate('draft')
}

const proceedWithUpdate = async () => {
  showIncompleteModal.value = false
  await performUpdate(pendingUpdateType.value)
}

const performUpdate = async (type: 'exam' | 'draft') => {
  try {
    updating.value = true
    const cleanedExamData = cleanExamData(examForm.value)
    cleanedExamData.exam_status = type === 'exam' ? 1 : 0
    
    await examService.updateExam(props.examId, cleanedExamData)
    showToast(`Exam ${type === 'exam' ? 'updated' : 'updated as draft'} successfully!`, 'success')
    
    emit('examUpdated')
    emit('back')
  } catch (err: any) {
    console.error(`Error ${type === 'exam' ? 'updating' : 'updating'} exam:`, err)
    showToast(err.response?.data?.message || `Failed to ${type === 'exam' ? 'update' : 'update'} exam`, 'error')
  } finally {
    updating.value = false
  }
}

// Lifecycle
onMounted(() => {
  loadExam()
})

return (_ctx: any,_cache: any) => {
  const _component_Plus = _resolveComponent("Plus")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("button", {
          onClick: handleBack,
          class: "flex items-center text-secondary-text dark:text-secondary-dark-text hover:text-primary-text dark:hover:text-primary-dark-text transition-colors mr-4"
        }, [
          _createVNode(_unref(ArrowLeft), { class: "w-5 h-5 mr-2" }),
          _cache[6] || (_cache[6] = _createTextVNode(" Back to Exams ", -1))
        ])
      ]),
      _cache[7] || (_cache[7] = _createElementVNode("h1", { class: "text-2xl sm:text-3xl font-bold text-primary-text dark:text-primary-dark-text mb-2" }, " Edit Exam ", -1)),
      _cache[8] || (_cache[8] = _createElementVNode("p", { class: "text-secondary-text dark:text-secondary-dark-text" }, " Update examination content, questions, and settings. ", -1))
    ]),
    (loading.value && !exam.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [...(_cache[9] || (_cache[9] = [
          _createElementVNode("div", { class: "animate-spin rounded-full h-8 w-8 border-b-2 border-primary mb-4" }, null, -1),
          _createElementVNode("span", { class: "text-primary-text dark:text-primary-dark-text" }, "Loading exam...", -1)
        ]))]))
      : (error.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_unref(AlertCircle), { class: "h-5 w-5 text-red-500 mr-2" }),
              _createElementVNode("span", _hoisted_7, _toDisplayString(error.value), 1)
            ]),
            _createElementVNode("button", {
              onClick: loadExam,
              class: "mt-2 text-sm text-red-600 dark:text-red-400 hover:text-red-800 dark:hover:text-red-200 underline"
            }, " Try again ")
          ]))
        : (exam.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("div", _hoisted_13, [
                        _createVNode(_unref(FileText), { class: "w-5 h-5 text-blue-600 dark:text-blue-400" })
                      ]),
                      _cache[10] || (_cache[10] = _createElementVNode("h3", { class: "text-lg font-semibold text-primary-text dark:text-primary-dark-text" }, " Basic Information ", -1))
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("div", null, [
                      _cache[11] || (_cache[11] = _createElementVNode("label", { class: "block text-sm font-medium text-primary-text dark:text-primary-dark-text mb-2" }, [
                        _createTextVNode(" Exam Name "),
                        _createElementVNode("span", { class: "text-red-500" }, "*")
                      ], -1)),
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((examForm.value.exam_name) = $event)),
                        type: "text",
                        class: "w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-primary focus:border-primary transition duration-200",
                        placeholder: "Enter exam name"
                      }, null, 512), [
                        [_vModelText, examForm.value.exam_name]
                      ])
                    ]),
                    _createElementVNode("div", null, [
                      _cache[13] || (_cache[13] = _createElementVNode("label", { class: "block text-sm font-medium text-primary-text dark:text-primary-dark-text mb-2" }, [
                        _createTextVNode(" Module "),
                        _createElementVNode("span", { class: "text-red-500" }, "*")
                      ], -1)),
                      _withDirectives(_createElementVNode("select", {
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((examForm.value.module_id) = $event)),
                        disabled: "",
                        class: "w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-gray-100 dark:bg-gray-700 text-gray-700 dark:text-gray-300 cursor-not-allowed transition duration-200"
                      }, [
                        _cache[12] || (_cache[12] = _createElementVNode("option", { value: 0 }, "Select a module", -1)),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(modules.value, (module) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: module.module_id,
                            value: module.module_id
                          }, _toDisplayString(module.name), 9, _hoisted_15))
                        }), 128))
                      ], 512), [
                        [
                          _vModelSelect,
                          examForm.value.module_id,
                          void 0,
                          { number: true }
                        ]
                      ]),
                      _cache[14] || (_cache[14] = _createElementVNode("p", { class: "mt-1 text-xs text-secondary-text dark:text-secondary-dark-text" }, " Module cannot be changed when editing an exam ", -1))
                    ]),
                    _createElementVNode("div", _hoisted_16, [
                      _createElementVNode("div", null, [
                        _cache[15] || (_cache[15] = _createElementVNode("label", { class: "block text-sm font-medium text-primary-text dark:text-primary-dark-text mb-2" }, [
                          _createTextVNode(" Passing Rate (%) "),
                          _createElementVNode("span", { class: "text-red-500" }, "*")
                        ], -1)),
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((examForm.value.passing_rate) = $event)),
                          type: "number",
                          min: "0",
                          max: "100",
                          class: "w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-primary focus:border-primary transition duration-200",
                          placeholder: "70"
                        }, null, 512), [
                          [
                            _vModelText,
                            examForm.value.passing_rate,
                            void 0,
                            { number: true }
                          ]
                        ])
                      ]),
                      _createElementVNode("div", null, [
                        _cache[16] || (_cache[16] = _createElementVNode("label", { class: "block text-sm font-medium text-primary-text dark:text-primary-dark-text mb-2" }, " Time Limit (minutes) ", -1)),
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((examForm.value.time_limit) = $event)),
                          type: "number",
                          min: "1",
                          max: "1440",
                          step: "1",
                          onInput: handleTimeLimitInput,
                          onKeypress: preventDecimalInput,
                          class: "w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-primary focus:border-primary transition duration-200",
                          placeholder: "No time limit"
                        }, null, 544), [
                          [
                            _vModelText,
                            examForm.value.time_limit,
                            void 0,
                            { number: true }
                          ]
                        ]),
                        _cache[17] || (_cache[17] = _createElementVNode("p", { class: "text-xs text-secondary-text dark:text-secondary-dark-text mt-1" }, " Leave empty for no time limit (max: 1440 minutes) ", -1))
                      ]),
                      _createElementVNode("div", null, [
                        _cache[18] || (_cache[18] = _createElementVNode("label", { class: "block text-sm font-medium text-primary-text dark:text-primary-dark-text mb-2" }, " Max Attempts ", -1)),
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((examForm.value.total_attempts) = $event)),
                          type: "number",
                          min: "1",
                          max: "10",
                          step: "1",
                          onInput: handleTotalAttemptsInput,
                          onKeypress: preventDecimalInput,
                          class: "w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-primary focus:border-primary transition duration-200",
                          placeholder: "Unlimited"
                        }, null, 544), [
                          [
                            _vModelText,
                            examForm.value.total_attempts,
                            void 0,
                            { number: true }
                          ]
                        ]),
                        _cache[19] || (_cache[19] = _createElementVNode("p", { class: "text-xs text-secondary-text dark:text-secondary-dark-text mt-1" }, " Leave empty for unlimited (max: 10 attempts) ", -1))
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("div", _hoisted_18, [
                    _createElementVNode("div", _hoisted_19, [
                      _createElementVNode("div", _hoisted_20, [
                        _createElementVNode("div", _hoisted_21, [
                          _createVNode(_unref(HelpCircle), { class: "w-5 h-5 text-green-600 dark:text-green-400" })
                        ]),
                        _createElementVNode("div", null, [
                          _createElementVNode("h3", _hoisted_22, " Questions (" + _toDisplayString(examForm.value.exam_content.questions.length) + "/10) ", 1),
                          _cache[20] || (_cache[20] = _createElementVNode("p", { class: "text-xs text-secondary-text dark:text-secondary-dark-text mt-1" }, " Each module must contain exactly 10 questions ", -1))
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_23, [
                    (examForm.value.exam_content.questions.length === 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                          _createElementVNode("div", _hoisted_25, [
                            _createVNode(_unref(HelpCircle), { class: "h-8 w-8 text-gray-400 dark:text-gray-500" })
                          ]),
                          _cache[21] || (_cache[21] = _createElementVNode("h3", { class: "text-lg font-medium text-gray-900 dark:text-white mb-2" }, "No questions found", -1)),
                          _cache[22] || (_cache[22] = _createElementVNode("p", { class: "text-gray-500 dark:text-gray-400" }, "This exam should have exactly 10 questions.", -1))
                        ]))
                      : _createCommentVNode("", true),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(examForm.value.exam_content.questions, (question, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: question.id,
                        class: _normalizeClass([
                   'border rounded-lg p-4 space-y-4',
                   incompleteQuestions.value[index]?.isComplete 
                     ? 'border-green-200 dark:border-green-700 bg-green-50 dark:bg-green-900/10' 
                     : 'border-red-200 dark:border-red-700 bg-red-50 dark:bg-red-900/10'
                 ])
                      }, [
                        _createElementVNode("div", _hoisted_26, [
                          _createElementVNode("div", _hoisted_27, [
                            _createElementVNode("h4", _hoisted_28, " Question " + _toDisplayString(index + 1), 1),
                            (incompleteQuestions.value[index]?.isComplete)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_29, " Complete "))
                              : (_openBlock(), _createElementBlock("span", _hoisted_30, " Incomplete "))
                          ])
                        ]),
                        (!incompleteQuestions.value[index]?.isComplete)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                              _cache[24] || (_cache[24] = _createElementVNode("p", { class: "text-red-700 dark:text-red-300 font-medium mb-1" }, "Required Fields:", -1)),
                              _createElementVNode("ul", _hoisted_32, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(incompleteQuestions.value[index]?.issues, (issue) => {
                                  return (_openBlock(), _createElementBlock("li", {
                                    key: issue,
                                    class: "flex items-center gap-1"
                                  }, [
                                    _cache[23] || (_cache[23] = _createElementVNode("span", { class: "w-1 h-1 bg-red-500 rounded-full" }, null, -1)),
                                    _createTextVNode(" " + _toDisplayString(issue), 1)
                                  ]))
                                }), 128))
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", null, [
                          _cache[26] || (_cache[26] = _createElementVNode("label", { class: "block text-sm font-medium text-primary-text dark:text-primary-dark-text mb-2" }, " Question Type ", -1)),
                          _withDirectives(_createElementVNode("select", {
                            "onUpdate:modelValue": ($event: any) => ((question.type) = $event),
                            onChange: ($event: any) => (updateQuestionType(question)),
                            class: "w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-primary focus:border-primary transition duration-200"
                          }, [...(_cache[25] || (_cache[25] = [
                            _createElementVNode("option", { value: "multiple_choice" }, "Multiple Choice", -1),
                            _createElementVNode("option", { value: "true_false" }, "True/False", -1),
                            _createElementVNode("option", { value: "essay" }, "Essay", -1)
                          ]))], 40, _hoisted_33), [
                            [_vModelSelect, question.type]
                          ])
                        ]),
                        _createElementVNode("div", null, [
                          _cache[27] || (_cache[27] = _createElementVNode("label", { class: "block text-sm font-medium text-primary-text dark:text-primary-dark-text mb-2" }, [
                            _createTextVNode(" Question Text "),
                            _createElementVNode("span", { class: "text-red-500" }, "*")
                          ], -1)),
                          _withDirectives(_createElementVNode("textarea", {
                            "onUpdate:modelValue": ($event: any) => ((question.question) = $event),
                            rows: "3",
                            class: "w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-primary focus:border-primary transition duration-200",
                            placeholder: "Enter your question..."
                          }, null, 8, _hoisted_34), [
                            [_vModelText, question.question]
                          ])
                        ]),
                        (question.type === 'multiple_choice' && question.options)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                              _cache[29] || (_cache[29] = _createElementVNode("label", { class: "block text-sm font-medium text-primary-text dark:text-primary-dark-text mb-2" }, [
                                _createTextVNode(" Answer Options "),
                                _createElementVNode("span", { class: "text-red-500" }, "*")
                              ], -1)),
                              _cache[30] || (_cache[30] = _createElementVNode("p", { class: "text-xs text-gray-500 dark:text-gray-400 mb-2" }, " Fill options in order (A, then B, then C, etc.). Empty options with filled options after them will show validation errors. ", -1)),
                              _createElementVNode("div", _hoisted_36, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(question.options, (option, optIndex) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    key: option.id,
                                    class: _normalizeClass(["radio-option-wrapper", { 'selected': getAnswerValue(question.id) === option.id }])
                                  }, [
                                    _createElementVNode("label", {
                                      class: "radio-option-label",
                                      for: `option_${question.id}_${option.id}`
                                    }, [
                                      _createElementVNode("div", _hoisted_38, [
                                        _createElementVNode("div", _hoisted_39, [
                                          _createElementVNode("input", {
                                            id: `option_${question.id}_${option.id}`,
                                            type: "radio",
                                            name: `correct_${question.id}`,
                                            value: option.id,
                                            checked: getAnswerValue(question.id) === option.id,
                                            onChange: ($event: any) => (setAnswerValue(question.id, option.id)),
                                            class: "radio-input"
                                          }, null, 40, _hoisted_40),
                                          _createElementVNode("div", _hoisted_41, [
                                            (getAnswerValue(question.id) === option.id)
                                              ? (_openBlock(), _createBlock(_unref(Check), {
                                                  key: 0,
                                                  class: "w-3 h-3"
                                                }))
                                              : _createCommentVNode("", true)
                                          ])
                                        ]),
                                        _createElementVNode("span", _hoisted_42, _toDisplayString(String.fromCharCode(65 + optIndex)) + ". ", 1),
                                        _withDirectives(_createElementVNode("input", {
                                          "onUpdate:modelValue": ($event: any) => ((option.text) = $event),
                                          type: "text",
                                          class: _normalizeClass([
                            'flex-1 px-3 py-2 border rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-primary focus:border-primary transition duration-200',
                            getOptionValidationClass(question, optIndex)
                          ]),
                                          placeholder: `Option ${String.fromCharCode(65 + optIndex)}`
                                        }, null, 10, _hoisted_43), [
                                          [_vModelText, option.text]
                                        ]),
                                        (question.options && question.options.length > 2)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                                              _createElementVNode("button", {
                                                onClick: ($event: any) => (removeOption(question, optIndex)),
                                                class: "remove-icon-btn text-red-500 hover:text-red-700 transition-colors hidden sm:inline-flex",
                                                type: "button",
                                                "aria-label": "Remove option"
                                              }, [
                                                _createVNode(_unref(X), { class: "w-4 h-4" })
                                              ], 8, _hoisted_45),
                                              _createElementVNode("button", {
                                                onClick: ($event: any) => (removeOption(question, optIndex)),
                                                class: "remove-text-btn text-red-500 hover:text-red-700 transition-colors inline-flex sm:hidden items-center px-2 py-1 text-sm rounded hover:underline",
                                                type: "button"
                                              }, " Remove ", 8, _hoisted_46)
                                            ]))
                                          : _createCommentVNode("", true)
                                      ])
                                    ], 8, _hoisted_37)
                                  ], 2))
                                }), 128)),
                                (question.options && question.options.length < 6)
                                  ? (_openBlock(), _createElementBlock("button", {
                                      key: 0,
                                      onClick: ($event: any) => (addOption(question)),
                                      type: "button",
                                      class: "text-sm text-blue-600 dark:text-blue-400 hover:text-blue-800 dark:hover:text-blue-200 flex items-center"
                                    }, [
                                      _createVNode(_component_Plus, { class: "w-4 h-4 mr-1" }),
                                      _cache[28] || (_cache[28] = _createTextVNode(" Add Option ", -1))
                                    ], 8, _hoisted_47))
                                  : _createCommentVNode("", true)
                              ])
                            ]))
                          : (question.type === 'true_false')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                                _cache[33] || (_cache[33] = _createElementVNode("label", { class: "block text-sm font-medium text-primary-text dark:text-primary-dark-text mb-3" }, [
                                  _createTextVNode(" Correct Answer "),
                                  _createElementVNode("span", { class: "text-red-500" }, "*")
                                ], -1)),
                                _createElementVNode("div", _hoisted_49, [
                                  _createElementVNode("label", {
                                    class: _normalizeClass(["true-false-option", { 'selected': getAnswerValue(question.id) === 'true' }]),
                                    for: `true_${question.id}`
                                  }, [
                                    _createElementVNode("input", {
                                      id: `true_${question.id}`,
                                      type: "radio",
                                      name: `correct_${question.id}`,
                                      value: "true",
                                      checked: getAnswerValue(question.id) === 'true',
                                      onChange: ($event: any) => (setAnswerValue(question.id, 'true')),
                                      class: "radio-input"
                                    }, null, 40, _hoisted_51),
                                    _createElementVNode("div", _hoisted_52, [
                                      _createElementVNode("div", _hoisted_53, [
                                        (getAnswerValue(question.id) === 'true')
                                          ? (_openBlock(), _createBlock(_unref(Check), {
                                              key: 0,
                                              class: "w-4 h-4"
                                            }))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _cache[31] || (_cache[31] = _createElementVNode("span", { class: "true-false-text" }, "True", -1))
                                    ])
                                  ], 10, _hoisted_50),
                                  _createElementVNode("label", {
                                    class: _normalizeClass(["true-false-option", { 'selected': getAnswerValue(question.id) === 'false' }]),
                                    for: `false_${question.id}`
                                  }, [
                                    _createElementVNode("input", {
                                      id: `false_${question.id}`,
                                      type: "radio",
                                      name: `correct_${question.id}`,
                                      value: "false",
                                      checked: getAnswerValue(question.id) === 'false',
                                      onChange: ($event: any) => (setAnswerValue(question.id, 'false')),
                                      class: "radio-input"
                                    }, null, 40, _hoisted_55),
                                    _createElementVNode("div", _hoisted_56, [
                                      _createElementVNode("div", _hoisted_57, [
                                        (getAnswerValue(question.id) === 'false')
                                          ? (_openBlock(), _createBlock(_unref(Check), {
                                              key: 0,
                                              class: "w-4 h-4"
                                            }))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _cache[32] || (_cache[32] = _createElementVNode("span", { class: "true-false-text" }, "False", -1))
                                    ])
                                  ], 10, _hoisted_54)
                                ])
                              ]))
                            : (question.type === 'essay')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_58, [
                                  _cache[34] || (_cache[34] = _createElementVNode("label", { class: "block text-sm font-medium text-primary-text dark:text-primary-dark-text mb-2" }, [
                                    _createTextVNode(" Keywords / Key Points "),
                                    _createElementVNode("span", { class: "text-red-500" }, "*")
                                  ], -1)),
                                  _createVNode(KeywordInput, {
                                    "model-value": getEssayKeywords(question.id),
                                    "onUpdate:modelValue": ($event: any) => (updateEssayKeywords(question.id, $event)),
                                    placeholder: "Enter keywords or key points for this essay question..."
                                  }, null, 8, ["model-value", "onUpdate:modelValue"])
                                ]))
                              : _createCommentVNode("", true)
                      ], 2))
                    }), 128)),
                    (examForm.value.exam_content.questions.length >= 3)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_59, [
                          _createElementVNode("button", {
                            onClick: scrollToTop,
                            type: "button",
                            class: "inline-flex items-center text-sm text-primary-text dark:text-primary-dark-text hover:underline"
                          }, [
                            _createVNode(_unref(ArrowUp), { class: "w-4 h-4 mr-2" }),
                            _cache[35] || (_cache[35] = _createTextVNode(" Back to top ", -1))
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_60, [
                _createElementVNode("div", _hoisted_61, [
                  _createElementVNode("div", _hoisted_62, [
                    _cache[43] || (_cache[43] = _createElementVNode("div", { class: "card-header" }, [
                      _createElementVNode("h3", { class: "text-lg font-semibold text-primary-text dark:text-primary-dark-text" }, " Exam Preview ")
                    ], -1)),
                    _createElementVNode("div", _hoisted_63, [
                      _createElementVNode("div", _hoisted_64, [
                        _cache[36] || (_cache[36] = _createElementVNode("span", { class: "text-sm text-secondary-text dark:text-secondary-dark-text" }, "Module", -1)),
                        _createElementVNode("span", _hoisted_65, _toDisplayString((examForm.value.module_id && examForm.value.module_id > 0) ? 'Selected' : 'Not selected'), 1)
                      ]),
                      _createElementVNode("div", _hoisted_66, [
                        _cache[37] || (_cache[37] = _createElementVNode("span", { class: "text-sm text-secondary-text dark:text-secondary-dark-text" }, "Questions", -1)),
                        _createElementVNode("span", _hoisted_67, _toDisplayString(examForm.value.exam_content.questions.length), 1)
                      ]),
                      _createElementVNode("div", _hoisted_68, [
                        _cache[38] || (_cache[38] = _createElementVNode("span", { class: "text-sm text-secondary-text dark:text-secondary-dark-text" }, "Complete Questions", -1)),
                        _createElementVNode("span", _hoisted_69, _toDisplayString(incompleteQuestions.value.filter(q => q.isComplete).length) + " / " + _toDisplayString(incompleteQuestions.value.length), 1)
                      ]),
                      _createElementVNode("div", _hoisted_70, [
                        _cache[39] || (_cache[39] = _createElementVNode("span", { class: "text-sm text-secondary-text dark:text-secondary-dark-text" }, "Passing Rate", -1)),
                        _createElementVNode("span", _hoisted_71, _toDisplayString(examForm.value.passing_rate || 0) + "% ", 1)
                      ]),
                      _createElementVNode("div", _hoisted_72, [
                        _cache[40] || (_cache[40] = _createElementVNode("span", { class: "text-sm text-secondary-text dark:text-secondary-dark-text" }, "Time Limit", -1)),
                        _createElementVNode("span", _hoisted_73, _toDisplayString(examForm.value.time_limit ? `${examForm.value.time_limit} min` : 'No limit'), 1)
                      ]),
                      _createElementVNode("div", _hoisted_74, [
                        _cache[41] || (_cache[41] = _createElementVNode("span", { class: "text-sm text-secondary-text dark:text-secondary-dark-text" }, "Max Attempts", -1)),
                        _createElementVNode("span", _hoisted_75, _toDisplayString(examForm.value.total_attempts ? `${examForm.value.total_attempts}` : 'Unlimited'), 1)
                      ]),
                      _createElementVNode("div", _hoisted_76, [
                        _createElementVNode("div", _hoisted_77, [
                          _cache[42] || (_cache[42] = _createElementVNode("span", { class: "text-sm font-medium text-primary-text dark:text-primary-dark-text" }, "Status", -1)),
                          (canSaveExam.value)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_78, " Ready to Save "))
                            : (_openBlock(), _createElementBlock("span", _hoisted_79, " Not Ready "))
                        ]),
                        (!canSaveExam.value)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_80, [
                              (!hasFormChanged.value)
                                ? (_openBlock(), _createElementBlock("p", _hoisted_81, "• No changes detected"))
                                : _createCommentVNode("", true),
                              (!examForm.value.exam_name || !examForm.value.exam_name.trim())
                                ? (_openBlock(), _createElementBlock("p", _hoisted_82, "• Enter exam name"))
                                : _createCommentVNode("", true),
                              (!examForm.value.passing_rate || examForm.value.passing_rate <= 0 || examForm.value.passing_rate > 100)
                                ? (_openBlock(), _createElementBlock("p", _hoisted_83, "• Set valid passing rate (1-100%)"))
                                : _createCommentVNode("", true),
                              (!examForm.value.module_id || examForm.value.module_id <= 0)
                                ? (_openBlock(), _createElementBlock("p", _hoisted_84, "• Select a module"))
                                : _createCommentVNode("", true),
                              (!incompleteQuestions.value.some(q => q.isComplete))
                                ? (_openBlock(), _createElementBlock("p", _hoisted_85, "• Complete at least one question"))
                                : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_86, [
                    _createElementVNode("div", _hoisted_87, [
                      _createElementVNode("button", {
                        onClick: updateExam,
                        disabled: !canSaveExam.value || updating.value,
                        class: "w-full btn btn-primary"
                      }, [
                        _createVNode(_unref(Save), { class: "w-4 h-4 mr-2" }),
                        _createTextVNode(" " + _toDisplayString(updating.value ? 'Updating...' : 'Update Exam'), 1)
                      ], 8, _hoisted_88),
                      _createElementVNode("button", {
                        onClick: updateExamAsDraft,
                        disabled: !canSaveAsDraft.value || updating.value,
                        class: "w-full btn btn-secondary"
                      }, [
                        _createVNode(_unref(FileText), { class: "w-4 h-4 mr-2" }),
                        _createTextVNode(" " + _toDisplayString(updating.value ? 'Updating...' : 'Update as Draft'), 1)
                      ], 8, _hoisted_89),
                      _createElementVNode("button", {
                        onClick: handleBack,
                        class: "w-full btn btn-outline"
                      }, " Cancel ")
                    ])
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true),
    _createVNode(IncompleteQuestionsModal, {
      "is-visible": showIncompleteModal.value,
      "incomplete-questions": modalQuestionsData.value,
      onClose: _cache[5] || (_cache[5] = ($event: any) => (showIncompleteModal.value = false)),
      onConfirm: proceedWithUpdate
    }, null, 8, ["is-visible", "incomplete-questions"])
  ]))
}
}

})